import React from 'react';
import Anthology from '../components/HomePage/Anthology';

const SBIPage = () => {
    return (
        <>
            <Anthology />
        </>
    );
}

export default SBIPage;
